// src/salesAssessment/SalesAssessmentDashboardWrapper.js
import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import {
  Assignment as AssignmentIcon,
  Compare as CompareIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import SalesAssessmentDashboard from './SalesAssessmentDashboard';
import SalesAssessmentComparisonDashboard from './SalesAssessmentComparisonDashboard';

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

const SalesAssessmentDashboardWrapper = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 1 }}>
        <Tabs value={tabValue} onChange={(e, val) => setTabValue(val)}>
          <Tab
            icon={<AssignmentIcon />}
            iconPosition="start"
            label={t('salesAssessment.dashboard.individualTests')}
          />
          <Tab
            icon={<CompareIcon />}
            iconPosition="start"
            label={t('salesAssessment.dashboard.comparisons')}
          />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <SalesAssessmentDashboard />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <SalesAssessmentComparisonDashboard />
      </TabPanel>
    </Box>
  );
};

export default SalesAssessmentDashboardWrapper;